import { Box, Container, Stack, Typography } from "@mui/material";
import Template from "@/templates/Templates";
import { BackButton } from "@/organism";
import useTemplateCreate from "./useTemplateCreate";

export const Create = () => {
  const { handleSubmit, isLoading } = useTemplateCreate();

  return (
    <Container maxWidth={"xl"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Stack direction={"column"} gap={1}>
          <BackButton to={"/template"}>템플릿 목록</BackButton>
          <Typography
            component={"h1"}
            variant="h5"
            fontWeight={"bold"}
            gutterBottom
          >
            템플릿 등록
          </Typography>
        </Stack>
      </Box>
      <Template.CreateForm onSubmit={handleSubmit} isLoading={isLoading} />
    </Container>
  );
};
